import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function LanguageSelector() {
  const {
    language,
    setLanguage
  } = useLanguage();
  return <AnimatePresence data-id="element-210">
      {!language && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0,
      transition: {
        duration: 0.5,
        ease: 'easeInOut'
      }
    }} className="fixed inset-0 z-[9999] bg-navy-900 flex flex-col items-center justify-center p-6" data-id="element-211">
          <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="w-full max-w-md flex flex-col items-center text-center" data-id="element-212">
            <img src="https://cdn.magicpatterns.com/uploads/ewmuY2XmHcFv7rR1BGg2Ew/logo_real_22.png" alt="Estructuras y Arcotechos" className="h-24 sm:h-32 w-auto object-contain mb-12" data-id="element-213" />

            <h1 className="text-2xl sm:text-3xl font-bold text-white mb-8" data-id="element-214">
              Select your language
              <br data-id="element-215" />
              <span className="text-xl sm:text-2xl text-gray-400 font-normal mt-2 block" data-id="element-216">
                Selecciona tu idioma
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 w-full" data-id="element-217">
              <button onClick={() => setLanguage('es')} className="flex-1 py-4 px-6 bg-amber hover:bg-amber-light text-navy-900 font-bold text-lg rounded-lg transition-colors duration-300 shadow-lg hover:shadow-amber/20" data-id="element-218">
                Español
              </button>
              <button onClick={() => setLanguage('en')} className="flex-1 py-4 px-6 bg-steel hover:bg-steel-light text-white font-bold text-lg rounded-lg transition-colors duration-300 shadow-lg hover:shadow-steel/20" data-id="element-219">
                English
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}